<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <div class="right-menu-item">
          <span>project:</span>
          <el-select
            v-model="diptListId"
            @change="deptChange"
            placeholder="请选择"
            @visible-change="getDeptListDFn"
            class="project-select"
          >
            <el-option
              v-for="item in diptList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="line"></div>
        </div>

        <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>
      </template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img src="@/assets/touxiang.webp" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <router-link to="/">
            <el-dropdown-item>Dashboard</el-dropdown-item>
          </router-link> -->
          <router-link to="/profile/index">
            <el-dropdown-item>Profile</el-dropdown-item>
          </router-link>
          <!-- <a target="_blank" href="https://github.com/PanJiaChen/vue-element-admin/">
            <el-dropdown-item>Github</el-dropdown-item>
          </a>
          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a> -->
          <router-link to="/example/mcp">
            <el-dropdown-item>MCP Setting</el-dropdown-item>
          </router-link>


          <router-link to="/example/base">
            <el-dropdown-item>Git Setting</el-dropdown-item>
          </router-link>
         
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">Log Out</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import Search from "@/components/HeaderSearch";
import Cookies from "js-cookie";

const TokenKey = "Admin-Token";
import {
  getDeptList,
  checkteDept,
  logoutAPI,
  deleteCodeServerAPI,
  updateLogoutTime,
} from "@/api/auth";
import { findUser } from "@/api/system/user";
import { clearLocalstorageAndSaveRememberMeStatus } from "@/util/index";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search,
  },
  data() {
    return {
      diptList: [],
      diptListId: this.$store.state.user.deptId,
      //  diptListId: "",
    };
  },
  created() {
    // alert(2)
    this.getDeptListDFn();
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"]),
  },
  methods: {
    ...mapMutations("tagsView", ["CLOSE_ALL_TAGAS"]),

    deptChange() {
      console.log(this.diptListId);

      checkteDept(this.diptListId).then((res) => {
        if (res.data.roleId) {
          commit("SET_ROLES", [roleMap[res.data.roleId]]);
        }
        sessionStorage.setItem("deptId", this.diptListId);
        this.$store.dispatch("GenerateRoutes");
        this.CLOSE_ALL_TAGAS({});
        this.$router.go(0);
      });
    },
    getDeptListDFn() {
      console.log("getDeptListDFn");
      getDeptList().then((res) => {
        this.diptList = res.data;
        this.diptList.forEach((item) => {
          item.label = item.deptName;
          item.value = item.deptId;
        });
      });
      this.getCurrentDeptRelevantPeople();
    },

    getCurrentDeptRelevantPeople() {
      var userOptions = [];
      var usersDict = {};
      findUser().then((res) => {
        userOptions = res.data;
        userOptions.forEach((userOption) => {
          usersDict[Number(userOption[0])] = userOption[1];
        });
        var userMember = [];
        getDeptList().then((getDeptListRes) => {
          let currentDeptId = sessionStorage.getItem("deptId");
          let currentDeptList = getDeptListRes.data.filter(
            (item) => item.deptId == currentDeptId
          );
          if (currentDeptList.length == 1) {
            userMember = currentDeptList[0].member;
            userOptions = userOptions.filter(
              (item) => userMember.indexOf(Number(item[0])) != -1
            );
            usersDict = {};
            userOptions.forEach((userOption) => {
              usersDict[Number(userOption[0])] = userOption[1];
            });
            this.$store.commit("SET_CURRENTPROJECTRELEVANTPEOPLE", usersDict);
          }
        });
      });
    },

    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      deleteCodeServerAPI().then((res) => {
        updateLogoutTime().then((res) => {
          logoutAPI().then((res) => {
            // 清除所有 cookies
            const cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
              const cookie = cookies[i];
              const eqPos = cookie.indexOf("=");
              const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
              document.cookie =
                name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            }
            // 清除 sessionStorage
            sessionStorage.clear();
            // 清除 localStorage
            // localStorage.clear();
            clearLocalstorageAndSaveRememberMeStatus();
            Cookies.remove(TokenKey);
            this.$router.push(`/login`);
            setTimeout(() => {
              window.history.go(0);
            }, 200);
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }
    .project-select {
      padding-right: 10px;
      // border-right: 1px solid #000;
    }
    .line {
      height: 70%;
      border: 1px solid #ccc;
    }

    .right-menu-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        display: flex;
        align-items: center;
        // margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
